import _ from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import { Col, Row, Table } from "reactstrap";
import { SortHeader } from ".";
import { api, dateHelpers, UserContext } from "../utils";

export default function SalesCallTrackingActionsGrid(props) {
  const { currentUser } = useContext(UserContext);
  const [data, setData] = useState();

  useEffect(() => {
    if (data !== props.data) {
      setData(props.data)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data])

  function onDelete(callActionId) {
    confirmAlert({
      title: "Confirm Deletion",
      message: 'Are you sure you\'d like to permanently delete this sales call?',
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            api.fetch("Order/DeleteSalesCallTrackingAction/" + callActionId).then(r => {
              if (r.data.success) {
                setData(
                  _.reject(data, x => x.salesCallActionId === callActionId)
                );
              } else {
                // setMessage({
                //   flavor: "alert-warning",
                //   text: r.data.message
                // });
              }
            })
              .catch(api.catchHandler);
          }
        },
        {
          label: "No"
        }
      ]
    });
  }

  return (<>
      <Row className="align-items-center">
        <Col className="transparent-background">
          {/* <ButtonGroup className="float-end">
              {data && data.length && props.exportXlsxCallback && (
                <Button
                  title="Download as .xlsx"
                  className="shredButtonExcel float-end ms-2"
                  onClick={getExcel}
                  disabled={working}
                >
                  <FontAwesomeIcon icon="file-excel" size="lg" />
                </Button>
              )}
            </ButtonGroup> */}
        </Col>
      </Row>
      <Table size="sm" className="data-table">
        <thead className="table-header">
          <tr style={{ paddingTop: "10px" }}>
            <th style={{ width: "7%", paddingLeft: "10px" }}>
              <SortHeader
                displayName="Action Date"
                field="ActionDate"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "ActionDate"}
                callback={props.sortCallback}
              />
            </th>
            <th style={{ width: "7%" }}>
              <SortHeader
                displayName={<span>Follow Up<br />Date</span>}
                field="FollowUpDate"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "FollowUpDate"}
                callback={props.sortCallback}
              />
            </th>
            <th style={{ width: "7%" }}>
              <SortHeader
                displayName={<span>Purpose<br />of Call</span>}
                field="PurposeOfCall"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "PurposeOfCall"}
                callback={props.sortCallback}
              />
            </th>
            <th style={{ width: "50%" }}>
              <SortHeader
                displayName="Notes"
                field="Notes"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "Notes"}
                callback={props.sortCallback}
              />
            </th>
            <th style={{ width: "10%" }}>
              <SortHeader
                displayName="Action Type"
                field="ActionType"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "ActionType"}
                callback={props.sortCallback}
              />
            </th>
            <th />
          </tr>
        </thead>
        <tbody>
          {_.map(data, (datum, index) => {
            return (
              <tr
                key={index}
                className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}
              >
                <td className="data-cell" children={dateHelpers.toLongDateString(datum.actionDate)} />
                <td className="data-cell" children={dateHelpers.toLongDateString(datum.followUpDate)} />
                <td className="data-cell" children={datum.purposeOfCall} />
                <td className="data-cell" children={datum.notes} />
                <td className="data-cell" children={datum.actionType} />
                {currentUser && (currentUser.isAdmin || currentUser.isPowerUser)
                  ? (<td className="boldedOrange cursor-pointer" onClick={() => props.actionFunction(datum.salesCallActionId)}>
                    Edit
                  </td>)
                  : null
                }
                {currentUser && (currentUser.isAdmin || currentUser.isPowerUser)
                  ? (<td className="boldedOrange cursor-pointer" onClick={() => onDelete(datum.salesCallActionId)}>
                    Delete
                  </td>)
                  : null
                }
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
}